// Central API client for the self-hosted backend (replaces Firebase).
// All calls go to the single Express API at REACT_APP_API_URL.

export const API_URL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_FIREBASE_FUNCTIONS_URL || // backward-compat fallback
  "https://api.begtools.xyz";

const TOKEN_KEY = "adminToken";

// react-snap loads the app in a headless browser at build time (UA "ReactSnap")
// where no backend is reachable. Returning a promise that never settles keeps
// components in their initial render and prevents network/parse errors from
// aborting the prerender crawl (react-snap treats a page error as fatal).
const IS_PRERENDER =
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
const prerenderPending = () => (IS_PRERENDER ? new Promise(() => {}) : null);

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

async function handle(res) {
  let body = null;
  try { body = await res.json(); } catch { /* non-json */ }
  if (!res.ok) {
    const err = new Error((body && body.error) || `Request failed (${res.status})`);
    err.status = res.status;
    err.code = body && body.code;
    err.body = body;
    throw err;
  }
  return body;
}

export async function apiGet(path, params) {
  const pending = prerenderPending();
  if (pending) return pending;
  const qs = params ? "?" + new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""))
  ).toString() : "";
  const res = await fetch(`${API_URL}${path}${qs}`, { headers: { ...authHeaders() } });
  return handle(res);
}

export async function apiPost(path, data) {
  const pending = prerenderPending();
  if (pending) return pending;
  const res = await fetch(`${API_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(data || {}),
  });
  return handle(res);
}

export async function apiDelete(path, data) {
  const pending = prerenderPending();
  if (pending) return pending;
  const res = await fetch(`${API_URL}${path}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(data || {}),
  });
  return handle(res);
}

export async function apiUpload(path, formData) {
  const pending = prerenderPending();
  if (pending) return pending;
  const res = await fetch(`${API_URL}${path}`, {
    method: "POST",
    headers: { ...authHeaders() }, // let the browser set multipart boundary
    body: formData,
  });
  return handle(res);
}
